export const SWIMLANE_DEFAULT_CONTENT_INSET_CLASS = 'pl-4 lg:pl-6' as const

// Scroll container with negative-margin + padding "bleed" so hover-scale and ranking
// badges are not clipped. Callers append their own gap (gap-4, or gap-2 md:gap-4).
export const SWIMLANE_SCROLL_BLEED_CLASS =
  'no-scrollbar -mt-2 -mb-12 flex w-full flex-1 overflow-x-auto pt-2 pb-12 select-none' as const
